import { ReactNode } from "react";
import { NextSeo, NextSeoProps } from "next-seo";
import { SEO as SEOnext } from "./../../../next-seo.config";
interface SeoProps extends NextSeoProps {
  title: string;
  description: string;
  path: string;
  children: ReactNode;
  konduto?: {
    property: string;
    content: string;
  };
}

export function SEO({ title, description, path, children, ...rest }: SeoProps) {
  const storeUrl = process.env.NEXT_PUBLIC_STORE_URL;
  const newPath = path.replace("/", "");
  const url = `${storeUrl + newPath}`;
  // console.log("storeUrl", storeUrl);
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={url}
        openGraph={{ url, title }}
        {...rest}
        additionalMetaTags={rest.konduto ? [rest.konduto] : []}
      />
      {children}
    </>
  );
}
